import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import React, {useEffect, useId, useState} from "react";
import useAuthorityConfiguration from "../../../../../api/utilities/useAuthorityConfiguration.js";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import useDataFileDownloadState from "../../../../../api/utilities/useDataFileDownloadState.js";
import {useTranslation} from "react-i18next";
import SimpleGrid from "../../../../../components/SimpleGrid.jsx";
import {useRenderCurrencyValue} from "../../../../../api/utilities/useValueRenderers.js";
import toast from "react-hot-toast";
import {useErrorTranslation} from "../../../../../api/utilities/translateErrorMessage.js";

export default function DailyOrderPerformance({title, day, project}) {

    let id = useId();

    let renderCurrencyValue = useRenderCurrencyValue();

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let [data, setData] = useState(null);
    let workerConfig = useAuthorityConfiguration();
    let dayKey = day.format('YYYY-MM-DD');

    let [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        let active = true;

        new ErpCalculationApi(workerConfig)
            .dailyOrderPerformance({
                projectId: project.id,
                dayInput: {
                    day: dayKey,
                }
            })
            .then((nextData) => {
                if (!active) {
                    return;
                }

                setData(nextData);
            })
            .catch(e => {
                if (!active) {
                    return;
                }

                et(e).then(toast.error);
            });

        return () => {
            active = false;
        };
    }, [dayKey, project.id]);

    let columns = [
        t('orders.centre'),
        t('orders.amount'),
        t('orders.turnover'),
        t('orders.average-order-price'),
    ];

    let columnClasses = [
        'text-left',
        'text-right whitespace-nowrap',
        'text-right whitespace-nowrap',
        'text-right whitespace-nowrap',
    ];

    useEffect(() => {
        let newDataSource = [];

        // noinspection JSUnresolvedReference
        for (let centreData of (data?.centres ?? [])) {
            // noinspection JSUnresolvedReference
            newDataSource.push([
                centreData.centreName,
                centreData.orderAmount,
                renderCurrencyValue(centreData.turnover),
                renderCurrencyValue(centreData.averageOrderPrice),
            ]);
        }

        setDataSource(newDataSource);
    }, [data]);

    // noinspection JSUnresolvedReference
    return (
        <LoadingComponent
            loading={data === null}
            className={'col-span-12 xl:col-span-6 text-slate-600 dark:text-slate-400'}
        >
            <div
                className="comp__roundedBox inline-flex flex-col w-full rounded-sm text-sm bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700">
                <header
                    className={'px-5 py-4 border-b border-gray-100 dark:border-gray-700/60'}>
                    <h2 className={'font-semibold text-gray-800 dark:text-gray-100'}>
                        {title}
                    </h2>
                </header>
                <div className="flex w-full px-4 py-2 justify-between items-start">
                    <div className="flex flex-col w-3/12">
                        <div className={'text-center text-3xl font-bold'}>{data?.ordersTotal ?? '-'}</div>
                        <div className={'text-center text-xs'}>{t('orders.orders-total')}</div>
                    </div>
                    <div className="w-9/12">
                        <SimpleGrid
                            columns={columns}
                            dataSource={dataSource}
                            columnClasses={columnClasses}
                        />
                    </div>
                </div>
            </div>
        </LoadingComponent>
    );
}
